// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__1VCKf","ul":"Header_ul__1KZ7w","nametag":"Header_nametag__1tMXr","avatar":"Header_avatar__2DnQ9"};